module.exports = __webpack_public_path__ + "static/media/logo.a22cffb3.svg";